<template lang="pug">
  .ssp-data-grid
    GenericTable(:loading="pg.isLoading()")
      template(slot="thead")
        slot(name="thead")
      slot
      template(slot="tfoot")
        slot(name="tfoot")
    GenericPagination(
      :sizeOptions="sizeOptions"
      :emptyMessage="emptyMessage"
      v-if="!withoutPagination" :page="pg" @update="reload()")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import GenericPagination from '@/components/common/GenericPagination'
import Page from '@/utils/common'

const DEFAULT_SIZE = 15
export default {
  props: {
    size: Number,
    sizeOptions: Array,
    fetch: Function, // return promise, on success result should have totalRecords
    urlPageParam: String, // parameter name to keep pagination in url
    withoutPagination: Boolean,
    emptyMessage: String // passed to pagination when table is empty
  },
  created() {
    this.reload()
  },
  data() {
    const page = this.urlPageParam && this.$route.query[this.urlPageParam]
    const size = this.urlPageParam && this.$route.query[`${this.urlPageParam}.size`]
    return {
      pg: new Page({
        page: Number(page || 1),
        size: Number(size || this.size || DEFAULT_SIZE)
      })
    }
  },
  methods: {
    reload(reset) {
      this.pg.setLoading(true)
      if (reset === true) {
        this.pg.setPage(1)
      }
      if (this.urlPageParam) {
        const query = {}
        query[this.urlPageParam] = this.pg.getPage()
        if (this.pg.getSize() !== DEFAULT_SIZE) {
          query[`${this.urlPageParam}.size`] = this.pg.getSize()
        }
        this.$router.push({ query })
      }
      if (this.pg.getPage() < 1) {
        console.warn('Page number < 1; Reseting it to 1') // eslint-disable-line
        this.pg.setPage(1)
      }
      this.fetch(this.pg)
        .then((totalRecords) => {
          this.pg.setLoading(false)
          if (typeof totalRecords === 'undefined') {
            console.warn('Please return totalRecords from your fetch promise.') // eslint-disable-line
          } else if (typeof totalRecords === 'number') {
            this.pg.setTotal(totalRecords)
            // check page out of bounds
            const last = this.pg.getLastPageNumber()
            if (last > 0 && this.pg.getPage() > last) {
              // current page greater then last SSP-2885
              // reload with last page number
              this.pg.setPage(this.pg.getLastPageNumber())
              this.reload(reset)
            }
          } else {
            console.warn('Invalid type of totalRecords', totalRecords) // eslint-disable-line
          }
        })
        .catch((e) => {
          this.pg.setLoading(false)
          this.$emit('error', e)
        })
    }
  },
  components: {
    GenericTable,
    GenericPagination
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/DataGrid.vue